import { forwardRef, Fragment } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import { BUILDER_STEPS } from '../consultationForms.const';

import CN from './FormBuilderStepper.module.scss';

export const FormBuilderStepper = forwardRef(({ currentStep = 1 }, ref) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  return (
    <div
      ref={ref}
      data-bem="FormBuilderStepper"
      className={cn(CN.component, {
        [CN.darkMode]: isDarkMode,
      })}
    >
      {BUILDER_STEPS.map((step, index) => (
        <Fragment key={step.number}>
          <div
            data-testid={`FormBuilderStepper__step-${step.number}`}
            className={cn(CN.step, {
              [CN.active]: step.number === currentStep,
              [CN.completed]: step.number < currentStep,
            })}
          >
            <div className={CN.stepCircle}>{step.number < currentStep ? <CheckCircleIcon className={CN.stepCheckIcon} /> : step.number}</div>
            <span className={CN.stepLabel}>{t(step.label)}</span>
          </div>
          {index < BUILDER_STEPS.length - 1 && (
            <div
              className={cn(CN.connector, {
                [CN.connectorActive]: currentStep > step.number,
              })}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
});
